export class ProdDetail {

    id: number;
    cat: number;
    quantity: number;
    name: string;
    price: number;
    total_ttc: number;
    comment: string;
    image: string[];
    rubric:any;
    display_lang:any;
    suggestions:any;

    constructor(
        id: any,
        cat: any,
        quantity: any,
        name: string,
        price: any,
        comment: string,
        image: string[],
        rubric: any,
        display_lang:any,
        suggestions:any
        
    ) {
        this.id = parseInt(id);
        this.cat = parseInt(cat);
        this.quantity = parseInt(quantity);
        this.name = name;
        this.price = parseFloat(price);
        this.total_ttc = this.getTotal();
        this.comment = comment;
        this.image = image;
        this.rubric=rubric;
        this.display_lang=display_lang;
        this.suggestions= suggestions
        
       
    }

    getTotal() {

        const total = this.price * this.quantity;
              return (Math.round(total * 100) / 100);
    }
}
